<template>
  <div v-if="showBanner" class="backdrop">
    <div class="modal">
      <p>
        We'd like to collect anonymous usage data (like visit time) to improve this website.<br>
        Do you agree to share this information?
      </p>
      <div class="buttons">
        <button class="accept" @click="acceptConsent">Yes, allow</button>
        <button class="decline" @click="declineConsent">No, thanks</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'

const showBanner = ref(false)

onMounted(() => {
  const consent = localStorage.getItem('usage_tracking_consent')
  if (!consent) {
    showBanner.value = true
  }
})

const acceptConsent = () => {
  localStorage.setItem('usage_tracking_consent', 'granted')
  showBanner.value = false
}

const declineConsent = () => {
  localStorage.setItem('usage_tracking_consent', 'denied')
  showBanner.value = false
}
</script>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent dark overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background-color: white;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
  font-size: 15px;
  line-height: 1.4;
  color: #1f2937;
}

.buttons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

button {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  font-weight: 500;
  border: none;
  cursor: pointer;
}

.accept {
  background-color: #4f46e5;
  color: white;
}

.decline {
  background-color: #e5e7eb;
  color: #1f2937;
}
</style>
